import { makeSelectors } from '@utils/css';
import { buttonCls } from './atoms/styles/ExpandCollapseButton.js';
export { boxCls, containerCls, contentCls, headingsCls, ribbonLabelCls, spacingCls } from './text-component.style.js';
export { extractTextCssTokens, tokens as textComponentTokens } from './design-tokens/index.js';

const TextComponentSelector = "text-component";
const textComponentSelectors = makeSelectors({
  toggleButton: buttonCls
});

export { TextComponentSelector, textComponentSelectors };
//# sourceMappingURL=index.selectors.js.map
